import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Map, Zap, TrendingUp, FileText } from 'lucide-react';
interface HallmarkSlide4Props {
  isDark?: boolean;
}
export function HallmarkSlide4({
  isDark = false
}: HallmarkSlide4Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  const cards = [{
    title: 'Baseline Leadership Wellness Map',
    desc: 'Clarity, Communication, Capacity, Crisis indicators across tiers.',
    icon: Map,
    color: 'slate'
  }, {
    title: 'Personalized Activation',
    desc: 'Individual 4C insights + learning + coach matching.',
    icon: Zap,
    color: 'mint'
  }, {
    title: 'Midpoint Wellness Trends',
    desc: 'Engagement data + emerging burnout or strain signals.',
    icon: TrendingUp,
    color: 'orange'
  }, {
    title: 'Executive Readout',
    desc: 'Clear summary + scale recommendation.',
    icon: FileText,
    color: 'navy'
  }];
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-68">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-69">
        {/* Header */}
        <motion.div variants={itemVariants} className="text-center mb-12 sm:mb-16" data-id="element-70">
          <h1 className={`text-3xl sm:text-5xl font-serif font-medium mb-4 sm:mb-6 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-71">
            What Hallmark Receives by Day 90
          </h1>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-72">
          {cards.map((card, idx) => <motion.div key={idx} variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 shadow-sm hover:shadow-md transition-all duration-300 flex items-start gap-6 ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige'}`} data-id="element-73">
              <div className={`w-14 h-14 rounded-2xl flex-shrink-0 flex items-center justify-center border ${isDark ? `bg-heliona-${card.color}/10 border-heliona-${card.color}/30` : `bg-heliona-${card.color}/10 border-heliona-${card.color}/20`}`} data-id="element-74">
                <card.icon className={`w-7 h-7 ${isDark ? `text-heliona-${card.color}` : `text-heliona-${card.color === 'mint' ? 'mint-dark' : card.color}`}`} data-id="element-75" />
              </div>
              <div data-id="element-76">
                <h3 className={`text-xl font-bold mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-77">
                  {card.title}
                </h3>
                <p className={`text-base leading-relaxed ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-78">
                  {card.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}